import BootstrapModal from 'react-bootstrap/lib/Modal';

export default BootstrapModal;
